import { useContext, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import algoliasearch from 'algoliasearch/lite';

import { TenantCtx, UserInfoCtx } from '../../containers/CommonLayout/CommonLayout';
import { GET_ALGOLIA_API_KEY } from '../../graphql/user';

const algoliaName = process.env.REACT_APP_ALGOLIA_APP_NAME || '';

const useSearchClient = (indexName?) => {
  const { tenant } = useContext(TenantCtx);
  const { userInfo, userLoading } = useContext(UserInfoCtx);

  const { data: algoliaData, loading: loadingAlgoliaData } = useQuery(GET_ALGOLIA_API_KEY, {
    skip: !userInfo,
  });

  const algoliaIndexName = [process.env.REACT_APP_ALGOLIA_INDEX_NAME, tenant?.name, indexName]
    .filter(Boolean)
    .join('_');

  const algoliaApiKey =
    userInfo && algoliaData?.getAlgoliaApiKey?.api_key
      ? algoliaData?.getAlgoliaApiKey?.api_key
      : process.env.REACT_APP_ALGOLIA_SEARCH_KEY;
  const loadingApiKey = userLoading || loadingAlgoliaData;

  const searchClient = useMemo(() => algoliasearch(algoliaName, algoliaApiKey), [algoliaApiKey]);

  return {
    searchClient,
    indexName: algoliaIndexName,
    loadingApiKey,
  };
};

export default useSearchClient;
